import { ContainerModule } from 'inversify';
import quizStoreModule, { QuizStoreModuleSymbol } from './quiz-store-module'
import { QuizQuerySymbol } from './quiz-query'

export const quizStateModule = new ContainerModule((bind) => {
  bind(QuizStoreModuleSymbol).toConstantValue(quizStoreModule);
  bind(QuizQuerySymbol).toDynamicValue((c) => c.container.get(QuizStoreModuleSymbol));
})
